import { FORM_ERROR } from 'final-form';
import _set from 'lodash/set';


export default ({ globalErrors, fieldErrors }, errorCodeToLangKey = null) => {
  const result = {};

  if (globalErrors) {
    const globalFormErrors = [];

    for (let i = 0; i < globalErrors.length; i++) {
      const { code, params } = globalErrors[i];
      const error = errorCodeToLangKey?.[code] || code;

      globalFormErrors.push({ error, params: (params || {}) });
    }

    _set(result, FORM_ERROR, globalFormErrors);
  }

  if (fieldErrors) {
    for (let i = 0; i < fieldErrors.length; ++i) {
      const { name, langKey, params } = fieldErrors[i];
      _set(result, name.split('.').concat(langKey), params);
    }
  }

  return result;
};
